import { shouldEnableBrowserSentry } from '@court-sync/shared';

export function isWebSentryEnabled(): boolean {
  return shouldEnableBrowserSentry({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    forceLocal: import.meta.env.VITE_SENTRY_ENABLE_LOCAL,
  });
}
